/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, Project, Site } from '../../models';
import { BulkSiteImportResultData } from '../../models/bulkSiteImportResultData';
import { ExcelSiteProperties } from '../logic-services/models/excelSiteProperties';

@Injectable({
    providedIn: 'root'
})
export class SitesImportDataService extends HttpBaseService {

    private _route = environment.api;

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    bulkSitesImport(appId: string, projId: string, excelSiteProperties: ExcelSiteProperties[], selectedSiteTemplateId: string): Observable<boolean> {
        const url = selectedSiteTemplateId ? `${this._route}apps/${appId}/projects/${projId}/bulk-sites-import?selectedSiteTemplateId=${selectedSiteTemplateId}` : `${this._route}apps/${appId}/projects/${projId}/bulk-sites-import`;
        return this.httpPost(url, excelSiteProperties);
    }

    importSitesFromShapefile(app: App, project: Project, siteImport: Site[], selectedSiteTemplateId: string): Observable<void> {
        const url = selectedSiteTemplateId ? `${this._route}apps/${app.id}/projects/${project.id}/import-shapefile?selectedSiteTemplateId=${selectedSiteTemplateId}` : `${this._route}apps/${app.id}/projects/${project.id}/import-shapefile`;
        return this.httpPost(url, siteImport);
    }

    checkBulkSitesProcessing(appId: string): Observable<BulkSiteImportResultData> {
        return this.httpGet(`${this._route}apps/${appId}/bulk-sites-processing`);
    }

}
